import { useState, useEffect } from "react";
import ProfileHeader from "./ProfileHeader";
import { uploadResume, getResumeData } from "../../../service/api";
import { toast } from "react-toastify";

function Resume() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  const [resumeInfo, setResumeInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Fetch resume status
  const fetchResumeStatus = async () => {
    try {
      const res = await getResumeData();
      setResumeInfo(res);
      console.log(res);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load resume data");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchResumeStatus();
  }, []);

  // Upload Resume
  const handleResumeUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please select a resume file");
      return;
    }

    try {
      const res = await uploadResume(file);

      toast.success(res.data.message);

      setShowModal(false);
      fetchResumeStatus(); // refresh resume status
    } catch (err) {
      toast.error(err.response?.data?.message);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div>
      <div className="titlSectionu userpaneltitle text-left position-relative">
        <h2>Resume List</h2>
        <p>Add and manage your resume</p>
      </div>

      <div className="card text-center p-3">
        {!resumeInfo?.status ? (
          <>
            <p>You have not uploaded a resume yet.</p>
            <button className="normalbtn" onClick={() => setShowModal(true)}>
              Upload Resume
            </button>
          </>
        ) : (
          <>
            <p>You already uploaded a resume.</p>

            <div className="d-flex justify-content-center">
              <a
                href={resumeInfo?.data?.fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="normalbtn mb-2"
                style={{
                  border: "1px solid #270b79",
                  backgroundColor: "#270b79",
                  marginRight: "10px",
                }}
              >
                View Resume
              </a>

              <button
                className="normalbtn mb-2"
                onClick={() => setShowModal(true)}
              >
                Update Resume
              </button>
            </div>
          </>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload Resume</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleResumeUpload}>
                  <div className="mb-3">
                    <label className="form-label">Select Resume File</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </div>

                  <button className="normalbtn w-100">Upload Resume</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Overlay */}
      {showModal && (
        <div
          className="modal-backdrop fade show"
          onClick={() => setShowModal(false)}
        ></div>
      )}
    </div>
  );
}

export default Resume;
